import { BitbucketIcon, ConfluenceIcon, JiraServiceDeskIcon, JiraSoftwareIcon, StatuspageIcon } from '@atlaskit/logo';

import { getConfig } from '../../../config';

import { TryProduct } from './index';

const { wacUrl } = getConfig();
const links: TryProduct[] = [
  {
    icon: JiraSoftwareIcon,
    name: 'Jira Software',
    url: `${wacUrl}/software/jira`,
  },
  {
    icon: ConfluenceIcon,
    name: 'Confluence',
    url: `${wacUrl}/software/confluence`,
  },
  {
    icon: JiraServiceDeskIcon,
    name: 'Jira Service Desk',
    url: `${wacUrl}/software/jira/service-desk`,
  },
  {
    icon: BitbucketIcon,
    name: 'Bitbucket',
    url: 'https://bitbucket.org/',
  },
  {
    icon: StatuspageIcon,
    name: 'Statuspage',
    url: `${wacUrl}/software/statuspage`,
  },
];

export const getWacProductLinks = () => links;
